import React from 'react';
import {
  Grid,
  makeStyles,
  createStyles,
  Theme,
  Typography,
  ButtonBase,
} from '@material-ui/core';
import { colors } from 'design-system';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    errorContainer: {
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(3),
      marginTop: 0,
    },
    errorCircle: {
      display: 'inline-block',
      width: 170,
      height: 170,
      borderRadius: 85,
      backgroundColor: '#F5F5F5',
    },
    errorCircleContent: {
      height: '100%',
    },
    errorImage: {
      marginTop: 0,
      marginBottom: 0,
      width: 600,
      height: 300,
    },
    fontCaption: {
      fontSize: 15,
      lineHeight: '22px',
    },
    fontTitle: {
      fontSize: 19,
      lineHeight: '24px',
      fontWeight: 900,
    },
  }),
);

type Props = {
  customerName: string;
};

const errorMessage: React.ReactNode = (
  <div>
    Si crees que es un error, por favor contacta a tu corredor de seguros,
    escríbenos al{' '}
    <ButtonBase
      onClick={(): Window | null => window.open(`https://wa.me/50625032772`)}
      id="sales-web-inspection-whatsapp-button"
      data-testid="whatsapp-button"
      style={{
        color: colors.bright_turquoise,
        fontWeight: 700,
        verticalAlign: 'bottom',
      }}
      component="span"
    >
      WhatsApp (506)2503-2772
    </ButtonBase>{' '}
    o a soporte técnico:{' '}
    <span style={{ textDecoration: 'underline' }}>
      soporteventasautocr@assanet.com
    </span>
  </div>
);

const ErrorIssuedLayout = ({ customerName }: Props): JSX.Element => {
  const classes = useStyles();

  return (
    <div className={classes.errorContainer}>
      <Grid container justifyContent="center" spacing={3}>
        <Grid
          item
          xs={12}
          sm={12}
          md={6}
          xl={4}
          container
          justifyContent="center"
          spacing={3}
        >
          <Grid item xs={12} container justifyContent="center">
            <img
              className={classes.errorImage}
              alt="error"
              src="/images/LandingPage.svg"
            />
          </Grid>
          <Grid item xs={12} sm={12} md={12} container justifyContent="center">
            <Typography
              variant="h2"
              align="center"
              className={classes.fontTitle}
              data-testid="default-title"
            >
              Esta póliza ya ha sido emitida.
            </Typography>
          </Grid>
          <Grid item xs={12} sm={12} md={12} container justifyContent="center">
            <Typography
              variant="caption"
              align="center"
              className={classes.fontCaption}
              data-testid="default-policy-description"
            >
              La póliza a nombre de {customerName} ya ha sido emitida.
            </Typography>
          </Grid>
          <Grid item xs={12} sm={12} md={12} container justifyContent="center">
            <Typography
              variant="caption"
              align="center"
              className={classes.fontCaption}
            >
              {errorMessage}
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
};

export default ErrorIssuedLayout;
